import languages from '../assets/data/locales.json';
import extendedLanguages from '../assets/data/locales_extend.json';
import countries from '../assets/data/countries.json';

export default {
  fetchLanguages() {
    return languages.map((language) => ({
      key: language.code,
      value: language.name
    }));
  },
  fetchExtendedLanguages() {
    return extendedLanguages
      .filter((language) => ['de', 'es', 'en', 'fr', 'pt', 'nl'].includes(language.code))
      .map((language) => ({
        key: language.code,
        value: language.name
      }));
  },
  fetchCountries(lang) {
    const countriesFormatted = countries.map((country) => {
      return {
        key: country.cca3,
        value: lang === 'en' ? country.name.common : country.translations[lang].common,
        timezones: country.timezones
      };
    });
    countriesFormatted.sort((a, b) => {
      if (a.text > b.text) {
        return 1;
      }
      if (a.text < b.text) {
        return -1;
      }
      return 0;
    });
    return countriesFormatted;
  }
};
